import { HttpErrorResponse } from '@angular/common/http';

export function extractErrorMessage(error: unknown, fallbackMessage: string): string {
  if (error instanceof HttpErrorResponse) {
    if (typeof error.error === 'string' && error.error.length > 0) {
      return error.error;
    }

    if (
      error.error &&
      typeof error.error === 'object' &&
      typeof (error.error as { message?: unknown }).message === 'string'
    ) {
      return (error.error as { message: string }).message;
    }

    return error.message || fallbackMessage;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
}
